
import 'swiper/css/swiper.css'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import { Component, Prop, Vue } from 'vue-property-decorator'
import ButtonFS from '~/components/common/buttons/ButtonFS.vue'
import Button from '~/components/common/buttons/DashboardButton.vue'
import Close from '~/components/common/ctrls/CloseCrossCtrl.vue'
import BasicModal from '~/components/common/modals/basic/Basic.vue'

@Component({
  components: {
    BasicModal,
    ButtonFS,
    Button,
    Close,
    Swiper,
    SwiperSlide
  }
})
export default class FreemiumModalWithVideo extends Vue {
  @Prop({
    type: Array,
    default: () => ([])
  }) title

  @Prop({
    type: String,
    default: ''
  }) referrer: string

  @Prop({
    type: String,
    default: ''
  }) mixpanelEvent: string // open from

  @Prop({
    type: Boolean,
    default: false
  }) isMob!: boolean

  freemiumContent = {
    title: [],
    subTitle: 'Access our full suite of strategy tools - take the next step and unlock Pro.',
    leftButton: {
      text: 'Upgrade to Pro plan',
      icon: 'padlock-open'
    },
    rightButton: {
      text: 'Nah, I\'ll risk it'
    }
  }

  swiperOptions = {
    allowTouchMove: false,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    }
  }

  onSwipeChange() {
    this.trackCarouselNav()
  }

  get carouselContent() {
    return [
      {
        title: 'Similar scholarships',
        description: 'Repurpose your essays to apply for similar scholarships, AI-generated based on your previous applications.',
        media: require('~/assets/images/similar-demo.gif')
      },
      {
        title: 'Customized recommendations',
        description: 'Apply for scholarships recommended for your profile and interests.',
        media: require('~/assets/images/recommended-demo.gif')
      },
      {
        title: 'Automatically reapply',
        description: 'Be automatically reapplied for scholarships with year-round winners.',
        media: require('~/assets/images/automatic-reapply-demo.gif')
      },
      {
        title: 'And so much more',
        description: 'Check credibility scores and see the number of applicants for each scholarship! Track your applications in real-time.',
        media: require('~/assets/images/pro-modal-features.png')
      }
    ]
  }

  mixpanelTrack(event) {
    if (this.$route.params.cardId) {
      const props = this.$mixpanel.fillProps(event, { scholarshipId: Number(this.$route.params.cardId) })
      if (this.mixpanelEvent) {
        props[`${this.$mixpanel.props.OPENED_FROM}`] = this.mixpanelEvent
      }
      this.$mixpanel.track(event, props)
    } else {
      const props = this.$mixpanel.fillProps(event)
      if (this.mixpanelEvent) {
        props[this.$mixpanel.props.OPENED_FROM] = this.mixpanelEvent
      }
      this.$mixpanel.track(event, props)
    }
  }

  trackCarouselNav() {
    this.mixpanelTrack(this.$mixpanel.events.PRO_MODAL_CAROUSEL_CLICK)
  }

  created() {
    this.mixpanelTrack(this.$mixpanel.events.UPGRADE_PRO_MODAL_VIEW)
  }

  close() {
    this.mixpanelTrack(this.$mixpanel.events.PRO_CHANCES_CLICK)
    this.$emit('close')
  }

  showPaymentModal() {
    this.mixpanelTrack(this.$mixpanel.events.UPGRADE_PRO_PLAN_CLICK)
    this.$emit('close')

    window.ppsdk?.open()
  }
}
